import React from "react";
import useSWR from "swr";
import api from "@/lib/api";
import { gbp, ddmmyyyy } from "@/lib/format";
import { Card } from "@/components/ui/card";

const fetcher = (url) => api.get(url).then((r) => r.data);

const DriverWork = () => {
  const { data, isLoading } = useSWR("/driver-portal/me", fetcher);
  if (isLoading || !data) return <div className="p-6 text-sm text-slate-500">Loading…</div>;
  const rows = data.recent_work || [];

  return (
    <div className="p-4 pt-6">
      <div className="text-[10px] uppercase tracking-[0.3em] text-brand-red font-mono">This period</div>
      <h1 className="font-heading text-2xl font-bold tracking-tight text-brand-text mt-1">Your work</h1>

      <div className="mt-4 space-y-2" data-testid="driver-work-list">
        {rows.map((r) => (
          <Card key={r.id} className="p-4 rounded-xl border-brand-border">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-heading font-bold text-brand-text">{ddmmyyyy(r.work_date)}</div>
                <div className="text-[11px] font-mono text-slate-500 mt-0.5">Route {r.route}</div>
              </div>
              <div className="font-heading text-lg font-bold text-brand-text">{gbp(r.route_payment)}</div>
            </div>
            <div className="mt-3 grid grid-cols-3 gap-2 text-center border-t border-slate-100 pt-3">
              <div><div className="text-[10px] uppercase tracking-wider text-slate-500">Stops</div><div className="font-heading font-bold">{r.stops}</div></div>
              <div><div className="text-[10px] uppercase tracking-wider text-slate-500">Parcels</div><div className="font-heading font-bold">{r.parcels}</div></div>
              <div>
                <div className="text-[10px] uppercase tracking-wider text-slate-500">Mileage</div>
                <div className="font-heading font-bold">
                  {r.mileage != null ? Number(r.mileage).toFixed(1) : "0.0"}
                </div>
              </div>
            </div>
          </Card>
        ))}
        {rows.length === 0 && <Card className="p-6 rounded-xl text-xs text-slate-500 text-center">No work yet.</Card>}
      </div>
    </div>
  );
};

export default DriverWork;
